import { PropsWithChildren } from 'react';

import { Breakpoints } from '@/utils/Breakpoint';
import { useMediaQuery } from 'react-responsive';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import NoAdminScreenForMobile from '@/pages/admin/NoAdminScreenForMobile';

export default function HideForMobile(props: PropsWithChildren) {
  const { children } = props;
  const isDektop = useMediaQuery({ minWidth: Breakpoints.lg });

  return (
    <ConditionalRenderer
      condition={isDektop}
      fallback={<NoAdminScreenForMobile />}
    >
      {children}
    </ConditionalRenderer>
  );
}
